document.querySelectorAll<HTMLElement>('.logo-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.logo-slider__wrapper');
	const nextButton = slider.querySelector<HTMLElement>('.logo-slider__button--next');
	const prevButton = slider.querySelector<HTMLElement>('.logo-slider__button--prev');

	if (!wrapper || !nextButton || !prevButton) return;

	const slideCount = wrapper.querySelectorAll('.swiper-slide').length;
	const autoScroll = slider.dataset.autoScroll === 'true';

	const buttons = slider.querySelectorAll<HTMLElement>('.logo-slide__btn');
	const navigation = slider.querySelectorAll<HTMLElement>('.logo-slider__button');

	const MARQUEE_SPEED = 6000;
	const ADVANCE_SPEED = 600;
	const ADVANCE_STEP = 3;
	const RESUME_DELAY = 2000;

	const updateNavigationVisibility = (s: typeof window.Swiper): void => {
		const isNavigationHidden = !autoScroll && slideCount <= s.loopedSlides;

		wrapper.parentElement?.classList.toggle('swiper-no-arrows', isNavigationHidden);
	};

	const updateSliderMargin = (): void => {
		if (buttons.length) {
			const tallestButtonHeight = Array.from(buttons).reduce((max, button) => {
				const height = button.offsetHeight;
				return height > max ? height : max;
			}, 0);

			navigation.forEach((button) => {
				button.style.marginBottom = `${tallestButtonHeight}px`;
			});

			slider.style.marginBottom = `-${tallestButtonHeight}px`;
		}
	};

	const swiperOptions: Record<string, unknown> = {
		slidesPerView: 1,
		spaceBetween: 32,
		loop: true,
		centerInsufficientSlides: true,
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
			992: {
				slidesPerView: 5,
				spaceBetween: 40,
			},
		},
		on: {
			init(s: typeof window.Swiper) {
				updateNavigationVisibility(s);
				updateSliderMargin();
			},
			breakpoint(s: typeof window.Swiper) {
				updateNavigationVisibility(s);
				updateSliderMargin();
			},
		},
	};

	if (autoScroll) {
		swiperOptions.speed = MARQUEE_SPEED;
		swiperOptions.allowTouchMove = false;
		swiperOptions.loopAdditionalSlides = slideCount;
		swiperOptions.autoplay = {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
		};
	} else {
		swiperOptions.navigation = {
			nextEl: nextButton,
			prevEl: prevButton,
		};
	}

	const swiper = new (window as Window).Swiper(wrapper, swiperOptions);

	if (!autoScroll) return;

	let resumeTimer: number | undefined;
	let isAdvancing = false;

	const resumeMarquee = (): void => {
		swiper.params.speed = MARQUEE_SPEED;
		swiper.autoplay?.start();
	};

	const advance = (direction: 'next' | 'prev'): void => {
		if (isAdvancing) return;
		isAdvancing = true;

		if (resumeTimer) {
			window.clearTimeout(resumeTimer);
			resumeTimer = undefined;
		}
		swiper.autoplay?.stop();

		const step = window.innerWidth < 768 ? 1 : ADVANCE_STEP;
		const offset = direction === 'next' ? step : -step;
		swiper.slideTo(swiper.activeIndex + offset, ADVANCE_SPEED);

		window.setTimeout(() => {
			swiper.loopFix?.();
			isAdvancing = false;
			resumeTimer = window.setTimeout(resumeMarquee, RESUME_DELAY);
		}, ADVANCE_SPEED);
	};

	nextButton.addEventListener('click', () => advance('next'));
	prevButton.addEventListener('click', () => advance('prev'));

	// Update margin on window resize
	window.addEventListener('resize', updateSliderMargin);
});
